import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HardHat, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const UnderConstructionOverlay = () => {
  const [open, setOpen] = useState(() => sessionStorage.getItem("g2a_construction_ack") !== "1");

  const dismiss = () => {
    sessionStorage.setItem("g2a_construction_ack", "1");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="construction-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0b1220]/80 backdrop-blur-md px-5"
        >
          <motion.div
            initial={{ opacity: 0, y: 28, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full max-w-md rounded-3xl border border-white/15 bg-[#101a2b] p-8 text-white shadow-2xl"
          >
            <button
              data-testid="construction-overlay-close"
              onClick={dismiss}
              aria-label="Close"
              className="absolute right-4 top-4 rounded-full p-2 text-white/60 transition-colors hover:bg-white/10 hover:text-white"
            >
              <X className="h-4 w-4" />
            </button>

            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-accent/20 text-accent">
              <HardHat className="h-6 w-6" />
            </div>

            <h2 className="mt-5 font-display text-2xl font-bold tracking-tight">
              Go2Alanya is still being built
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-white/70">
              You are early. The site is in an active building phase, so some activities,
              prices and bookings are still test data and may change or not work yet.
              Feel free to look around.
            </p>

            <Button
              data-testid="construction-overlay-continue"
              onClick={dismiss}
              className="mt-7 w-full rounded-xl bg-accent text-accent-foreground hover:bg-accent/90"
            >
              Continue to preview
            </Button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
